import React from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Pagination from 'react-bootstrap/Pagination';
import { useSearchParams } from 'react-router-dom';

function PaginationPanel(props) {
  const { total, active, setActive } = props;

  const [searchParams, setSearchParams] = useSearchParams();

  if (total < 2) return false;

  let isPrevEllipsis = false;
  const itemsLeftSideCount = active - 1;
  const itemsRightSideCount = total - active;

  const setActiveHandler = (page) => {
    let oldSearchParams = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of searchParams.entries()) {
      oldSearchParams = {
        ...oldSearchParams,
        [key]: value
      };
    }

    setSearchParams({
      ...oldSearchParams,
      page
    });
    setActive(page);
  };

  return (
    <Pagination className="pagination_text">
      <Pagination.Prev
        onClick={() => {
          if (active > 1) setActiveHandler(active - 1);
        }}
        disabled={active === 1}
      >
        <ArrowBackIosIcon />
      </Pagination.Prev>
      {Array.from({ length: total }, (_, index) => index + 1).map((item) => {
        if (
          item === 1 ||
          item === total ||
          item === active ||
          (itemsLeftSideCount <= 3 && item <= active) ||
          (itemsLeftSideCount > 3 && item === active - 1) ||
          (itemsRightSideCount <= 3 && item >= active) ||
          (itemsRightSideCount > 3 && item === active + 1) ||
          (itemsLeftSideCount < 3 && itemsRightSideCount > 3 && item - active <= 4 - itemsLeftSideCount) ||
          (itemsRightSideCount < 3 && itemsLeftSideCount > 3 && active - item <= 4 - itemsRightSideCount)
        ) {
          isPrevEllipsis = false;
          return (
            <Pagination.Item key={item} active={item === active} onClick={() => setActiveHandler(item)}>
              {item}
            </Pagination.Item>
          );
        }

        if (isPrevEllipsis) return null;
        isPrevEllipsis = true;
        return <Pagination.Ellipsis key={item} disabled />;
      })}
      <Pagination.Next
        onClick={() => {
          if (active < total) setActiveHandler(active + 1);
        }}
        disabled={active === total}
      >
        <ArrowForwardIosIcon />
      </Pagination.Next>
    </Pagination>
  );
}

export default PaginationPanel;
